import {
    Box,
    Skeleton,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import { Order, TableHeadComponentProps, TableHeadLoaderProps, TableHeaderData } from "../../types";
import { InvertedTriangleIcon } from "../../../../assets/SvgIcons";
import { visuallyHidden } from "@mui/utils";


const TableHeadLoader = ({
    rowCustomStyles,
    colsNum
}: TableHeadLoaderProps) => {
    const theme = useTheme()

    return (
        <>
            <TableRow
                sx={{
                    '& td': {
                        paddingTop: "15px",
                        paddingBottom: "15px",
                        borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                    },
                    ...rowCustomStyles
                }}
            >
                {[...Array(colsNum)].map((_, index) => (
                    <TableCell key={index} width="540px">
                        <Skeleton animation="wave" variant="text" />
                    </TableCell>
                ))}
            </TableRow>
        </>
    )
};

export default function TableHeadComponent(
    {
        isLoading,
        tableHeadRowCustomStyles,
        tableHeaderData,
        handleSort,
        tableDataCount,
        order,
        orderBy
    }: TableHeadComponentProps
): JSX.Element {
    const theme = useTheme()

    const onSortIconClick = (
        id: string
    ) => {
        const isAsc = orderBy === id && order === "asc";

        handleSort(id, isAsc ? "desc" : "asc")
    };

    return (
        <TableHead>
            {isLoading && (
                <TableHeadLoader
                    rowCustomStyles={tableHeadRowCustomStyles}
                    colsNum={tableHeaderData.length}
                />
            )}
            {!isLoading && tableDataCount > 0 && (
                <TableRow
                    sx={{
                        '& th': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                        },
                        ...tableHeadRowCustomStyles
                    }}
                >
                    {tableHeaderData.map((currentHeader: TableHeaderData) => (
                        <TableCell
                            key={currentHeader?.id}
                            align={currentHeader?.align ?? "left"}
                            // sx={currentHeader?.headerTableCellStyle ?? {}}
                            sx={{
                                ...(currentHeader?.headerTableCellStyle ?? {})
                            }}
                        >
                            {currentHeader.isSortable ? (
                                <TableSortLabel
                                    active={orderBy === currentHeader.id}
                                    direction={orderBy === currentHeader.id ? order : "asc"}
                                    onClick={() => !isLoading && onSortIconClick(currentHeader.id)}
                                    IconComponent={InvertedTriangleIcon}
                                >
                                    <Typography
                                        variant="subtitle_500"
                                        sx={(theme: Theme) => ({
                                            color: theme.palette.grey[800],
                                            letterSpacing: '0.02px',
                                            lineHeight: '17px',
                                        })}
                                    >
                                        {currentHeader?.label ? currentHeader.label.toUpperCase() : ''}
                                        {orderBy === currentHeader.id ? (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === "desc" ? "sorted descending" : "sorted ascending"}
                                            </Box>
                                        ) : null}
                                    </Typography>
                                </TableSortLabel>
                            ) : (
                                <Typography
                                    variant="subtitle_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.grey[800]
                                    })}
                                >
                                    {currentHeader?.label ? currentHeader.label.toUpperCase() : ''}
                                </Typography>
                            )}
                        </TableCell>
                    ))}
                </TableRow>
            )
            }
        </TableHead >
    )
}